<template>
  <div class="lila-chart-container">
    <Doughnut
      :data="chartData"
      :options="mergedOptions"
    />
  </div>
</template>

<script setup>
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "vue-chartjs";
import { computed } from "vue";

ChartJS.register(ArcElement, Tooltip, Legend);

const props = defineProps({
  chartData: {
    type: Object,
    required: true
  },
  options: {
    type: Object,
    default: () => ({})
  }
});

const mergedOptions = computed(() => ({
  responsive: true,
  maintainAspectRatio: false,
  ...props.options
}));
</script>

<style scoped>
.lila-chart-container {
  position: relative;
  width: 100%;
  height: 100%;
}
</style>
